import { render, staticRenderFns } from "./ParametrizacaoUsuarioModal.vue?vue&type=template&id=f93ca8a2&scoped=true"
import script from "./ParametrizacaoUsuarioModal.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoUsuarioModal.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoUsuarioModal.vue?vue&type=style&index=0&id=f93ca8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93ca8a2",
  null
  
)

export default component.exports